module.exports = "<div ncy-breadcrumb></div> <div class=r> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <h1> <div><span>Verzending</span> {{ ::vm.order.number }}</div> <div class=\"type-base m-y-1\"> <div>Aangemaakt op <strong>{{ ::vm.order.createdOn | date:'d MMMM yyyy'}}</strong></div> <div>Naar <strong>{{ ::vm.order.receiver.name }}</strong></div> </div> </h1> </div> </div> <order-detail-content order=vm.order confirmation=false></order-detail-content>";


//////////////////
// WEBPACK FOOTER
// ./features/account/my-packages/pod-order-detail.html
// module id = 537
// module chunks = 0